import { Theme } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import AppSettings from "../constants/AppSettings";

interface MatchParams {
  userType: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.header.background.main,
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  text: {
    color: theme.footer.text.primary,
    fontSize: theme.typography.pxToRem(20),
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },
  spinner: {
    color: theme.footer.text.primary,
    marginBottom: theme.spacing(2),
  },
}));

const isAndroid = /Android/i.test(navigator.userAgent);
const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

const Download: React.FC = () => {
  const classes = useStyles();
  const { userType } = useParams<MatchParams>();
  const { t } = useTranslation();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    async function handleRedirect(): Promise<void> {
      if (!userType || isRedirecting) return;

      setIsRedirecting(true);

      // Wait 1.5 seconds so users can see the loading screen
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // After 1.5 seconds, redirect to appropriate store
      const isTrainer = userType === "trainer";
      if (isAndroid) {
        window.location.href = isTrainer
          ? AppSettings.Links.TrainerGooglePlayStoreLink
          : AppSettings.Links.GooglePlayStoreLink;
      } else if (isIOS) {
        window.location.href = isTrainer
          ? AppSettings.Links.TrainerAppStoreLink
          : AppSettings.Links.AppStoreLink;
      } else {
        // For desktop, default to Play Store
        window.location.href = isTrainer
          ? AppSettings.Links.TrainerGooglePlayStoreLink
          : AppSettings.Links.GooglePlayStoreLink;
      }
    }

    handleRedirect();
  }, [userType, isRedirecting]);

  const getMessage = () => {
    if (userType === "trainer") {
      return t("Redirecting to download Rambody Trainer app...");
    }
    if (userType === "athlete") {
      return t("Redirecting to download Rambody Athlete app...");
    }
    return t("Redirecting to app store...");
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.text}>{getMessage()}</Typography>
      <CircularProgress className={classes.spinner} />
    </div>
  );
};

export default Download;
